<template>
    <b-card class="shadowed p-2">
        <b-skeleton animation="fade" height="19px" width="80px" class="mb-2" />
        <b-skeleton animation="fade" height="14px" width="90px" />
        <b-skeleton animation="fade" height="14px" width="100%" />
        <div class="text-center my-3">
            <b-skeleton-icon
                icon="circle-fill"
                :icon-props="{ fontScale: 15 }"
            />
        </div>
        <b-skeleton animation="fade" height="11px" width="125px" />
        <b-skeleton-img animation="fade" height="40px" width="125px" no-aspect />
        <div class="mt-3 ml-auto d-flex justify-content-end align-items-center">
            <b-skeleton animation="fade" height="11px" width="110px" />
            <b-skeleton type="button" animation="fade" class="ml-2" />
        </div>
    </b-card>
</template>

<script>
    import mobileCheckMixin from "../../mixins/mobileCheckMixin";

    export default {
        name: "ServiceListSkeleton",
        mixins: [mobileCheckMixin]
    }
</script>